<template>
    <div class="tabs noscroll layout-column">
        <div class="wrapper_header_sidebar">
            <div class="header_sidebar_wrpr">
	            <a @click="linkTo(null)" class="small-btn back_btn">
		            <inline-svg :src="require('@/assets/icons/back.svg')" />
	            </a>
                <h4 class="title_sidebar">Popup properties</h4>
	            <span class="name">{{current_popup ? current_popup.name : ''}}</span>
            </div>
            <ul id="tabs-nav">
                <li><a :class="{'active': currentTab === 'basic'}" @click="currentTab = 'basic'">Basic</a></li>
                <li><a :class="{'active': currentTab === 'advanced'}" @click="currentTab = 'advanced'">Advanced</a></li>
            </ul>
        </div>

        <div id="tabs-content" class="scroll">
            <div class="tab-content" v-show="currentTab === 'basic'">
	            <selectItem title="Width" :options="[{id:'small',text:'Small'},{id:'medium',text:'Medium (default)'},
	            {id:'large',text:'Large'},{id:'fullscreen',text:'Full-screen'}]"
	                        @updated="debUpdate($event, 'width', 'basic')" :value="basic.width"/>

              <colorPicker title="Background color" @updated="debUpdate($event, 'backgroundColor', 'basic')" :value="basic.backgroundColor"/>
	            <imageUploader title="Background image" @updated="debUpdate($event, 'backgroundImage', 'basic')" :value="basic.backgroundImage"/>

	            <selectItem title="Background style" :options="[{id:'auto',text:'Auto (default)'},{id:'cover',text:'Cover'}]"
	                        @updated="debUpdate($event, 'backgroundStyle', 'basic')" :value="basic.backgroundStyle"/>

	            <selectItem title="Background position" :options="[{id:'top',text:'Top (default)'},{id:'center',text:'Center'},{id:'bottom',text:'Bottom'}]"
	                        @updated="debUpdate($event, 'backgroundPosition', 'basic')" :value="basic.backgroundPosition"/>

	            <marginPadding v-if="basic.padding" title="Padding" @updated="debUpdate($event, 'padding', 'basic')" :value="basic.padding"/>

              <FontPanel v-if="basic.font" title="Font" @updated="debUpdate($event, 'font', 'basic')" :value="basic.font"/>

	            <Border v-if="basic.border" title="Border" @updated="debUpdate($event, 'border', 'basic')" :value="basic.border"/>
            </div>
            <div class="tab-content" v-show="currentTab === 'advanced'">
                <TextInput title="ID" :value="advanced.id" @updated="debUpdate($event, 'id', 'advanced')"/>
                <MultiSelectItem title="CSS classes" :value="advanced.cssClasses" @updated="debUpdate($event, 'cssClasses', 'advanced')"/>
            </div>
        </div>
    </div>
</template>

<script>
import colorPicker from "@/modules/page-editor/src/components/sidebar/sidebar-items/colorPicker.vue"
import imageUploader from "@/modules/page-editor/src/components/sidebar/sidebar-items/imageUploader.vue"
import TextInput from "@/modules/page-editor/src/components/sidebar/sidebar-items/TextInput.vue"
import marginPadding from "@/modules/page-editor/src/components/sidebar/sidebar-items/marginPadding.vue"
import Border from "@/modules/page-editor/src/components/sidebar/sidebar-items/Border.vue"
import selectItem from "@/modules/page-editor/src/components/sidebar/sidebar-items/selectItem.vue"
import InputNumber from "@/modules/page-editor/src/components/sidebar/sidebar-items/InputNumber.vue"
import ToggleInput from "@/modules/page-editor/src/components/sidebar/sidebar-items/ToggleInput.vue"
import ListItems from "@/modules/page-editor/src/components/sidebar/sidebar-items/ListItems.vue"
import Font from "@/modules/page-editor/src/components/sidebar/sidebar-items/Font.vue"
import ClickAction from "@/modules/page-editor/src/components/sidebar/sidebar-items/ClickAction.vue"
import TextAlign from "@/modules/page-editor/src/components/sidebar/sidebar-items/TextAlign.vue"
import FontStyling from "@/modules/page-editor/src/components/sidebar/sidebar-items/FontStyling.vue"
import FontPanel from "@/modules/page-editor/src/components/sidebar/sidebar-items/FontPanel.vue"
import SocialNetworks from "@/modules/page-editor/src/components/sidebar/sidebar-items/SocialNetworks.vue"
import PopupOpenBtn from "@/modules/page-editor/src/components/sidebar/sidebar-items/PopupOpenBtn.vue"
import MultiSelectItem from "@/modules/page-editor/src/components/sidebar/sidebar-items/MultiSelectItem.vue"
import debounceAction from "@/helpers/debounce"
import {mapGetters} from "vuex";

export default {
    name: 'PopupProperties',
    components: {
        colorPicker,
        imageUploader,
        TextInput,
        marginPadding,
        Border,
        selectItem,
        InputNumber,
        ToggleInput,
        ListItems,
        Font,
        ClickAction,
        TextAlign,
        FontStyling,
        FontPanel,
        SocialNetworks,
        PopupOpenBtn,
        MultiSelectItem
    },
    data() {
        return {
            currentTab: 'basic',
        }
    },
    computed: {
    	...mapGetters(['current_popup']),
	    basic() {
		    return this.current_popup && this.current_popup.attributes ? this.current_popup.attributes.basic || {} : {};
	    },
	    advanced() {
		    return this.current_popup && this.current_popup.attributes ? this.current_popup.attributes.advanced || {} : {};
	    },
    },
    methods: {
        linkTo(tab) {
            this.$store.commit('PAGE_SET_TAB', tab)
        },
        debUpdate: debounceAction(function(ev, name, type) {
            this.onFieldUpdate(ev, name, type)
        }, 100),
        onFieldUpdate(ev, name, type) {
            // console.log({ev, name, type});
            this.$store.dispatch('PAGE_SET_POPUP_PROPS', {type, name, item: ev});
        }
    }
}
</script>
